import type { RouteRecordRaw } from 'vue-router';

const PublicLayout = () => import('@/shared/layouts/pages/PublicLayout/index.vue');

const LoginPage = () => import('@/modules/authentication/pages/Login/index.vue');
const SignUpPage = () => import('@/modules/authentication/pages/SignUp/index.vue');
const MailConfirmationPage = () => import('@/modules/authentication/pages/MailConfirmation/index.vue');
const RecoverPasswordPage = () => import('@/modules/authentication/pages/RecoverPassword/index.vue');
const ResetPasswordPage = () => import('@/modules/authentication/pages/ResetPassword/index.vue');
const SignUpConfirmationPage = () => import('@/modules/authentication/pages/SignUpConfirmation/index.vue');
const ResendConfirmationEmailPage = () => import('@/modules/authentication/pages/ResendConfirmationEmail/index.vue');
const InvitationView = () => import('@/modules/miniOnboarding/pages/InvitationContainer/index.vue');

export const authPublicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    component: PublicLayout,
    children: [
      {
        path: 'log-in',
        name: 'log-in',
        component: LoginPage,
      },
      {
        path: 'sign-up',
        name: 'sign-up',
        component: SignUpPage,
      },
      {
        path: 'mail-sign-up-confirmation/:email',
        name: 'mail-sign-up-confirmation',
        component: SignUpConfirmationPage,
      },
      {
        path: 'resend-email-verification-link',
        name: 'resend-email-verification-link',
        component: ResendConfirmationEmailPage,
      },
      {
        path: 'recover-password',
        name: 'recover-password',
        component: RecoverPasswordPage,
      },
      {
        path: 'reset-password',
        alias: '/resetPassword',
        name: 'reset-password',
        component: ResetPasswordPage,
      },
      {
        path: 'mail-confirmation/:email',
        name: 'mail-confirmation',
        component: MailConfirmationPage,
      },
      {
        path: 'user-invitation',
        name: 'user-invitation',
        component: InvitationView,
      },
    ],
  },
];
